import Layout from '@/layout';
var kemaiRouter = {
  path: '/kemai',
  component: Layout,
  redirect: '/kemai/store-binding',
  name: 'Kemai',
  meta: {
    title: '科脉管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'store-binding',
    name: 'KemaiStoreBinding',
    component: function component() {
      return import('@/views/pet/retail/storeBinding');
    },
    meta: {
      title: '门店仓库绑定',
      icon: ''
    }
  }, {
    path: 'store-sync',
    name: 'KemaiStoreSync',
    component: function component() {
      return import('@/views/pet/retail/storeSync');
    },
    meta: {
      title: '门店仓库同步',
      icon: ''
    }
  }, {
    path: 'stock',
    name: 'KemaiStock',
    component: function component() {
      return import('@/views/pet/retail/stock');
    },
    meta: {
      title: '库存展示配置',
      icon: ''
    }
  }, {
    path: 'region-rule',
    name: 'KemaiRegionRule',
    component: function component() {
      return import('@/views/pet/retail/regionRule');
    },
    meta: {
      title: '配送自取规则',
      icon: ''
    }
  }]
};
export default kemaiRouter;